import { i18n, inject, observer, pr, React, RouteComponentProps, ui, theme } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { InfoBoxWithBackground } from "components/common/InfoBoxWithBackground";
import { FormattedHTMLMessage } from "react-intl";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
}

@inject("externalInterfaceStore")
@observer
export class IchAppSuccess extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                useWebVersion
                variant="success"
                title={ui.__("ichApp.success.title")}
                message={ui.__("ichApp.success.message")}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ichApp/IchAppSuccess.tsx